/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useMemo, useState} from 'react'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {KTSVG} from '../../../../_metronic/helpers'
import SupportTicketPopup from './Modal/SupportTicketPopup'
import Select from 'react-select'

const SupportTicketPage: FC = () => {
  const [openSupportTicketPopup, setOpenSupportTicketPopup] = useState(false)
  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  const [filter, setFilter] = useState({
    status: {value: '', label: 'Select Status'},
  })
  const SupportTicketPopupModal = useMemo(
    () => (
      <SupportTicketPopup
        show={openSupportTicketPopup}
        handleClose={() => setOpenSupportTicketPopup(false)}
      />
    ),
    [openSupportTicketPopup]
  )
  return (
    <>
      {SupportTicketPopupModal}
      <div className='card mb-0 pt-7'>
        <div className='card-header align-items-center border-bottom-0'>
          {/* ///////////////////////////////////// */}
          <div className='d-flex align-items-start position-relative my-1 flex-column flex-sm-row'>
            <div className='relative'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6 mt-3'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
              />
            </div>
            <div
              onMouseEnter={() => setFilterOpen(true)}
              onMouseLeave={() => setFilterOpen(false)}
              className='filter_parent'
            >
              <button
                className={`btn btn-light-primary ms-3 me-3 filter_btn ${
                  filterOpen && 'show menu-dropdown'
                } `}
                data-kt-menu-placement='bottom-end'
              >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
              </button>

              <div
                className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
                  filterOpen && 'show filtermenu'
                }`}
              >
                <div className='px-7 py-5'>
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Status:</label>

                    <div>
                      <Select
                        name='status'
                        value={filter.status}
                        className='form-select form-select-solid fw-bolder'
                        onChange={(e: any) => setFilter({...filter, status: e})}
                        options={[
                          {value: '', label: 'Select Status'},
                          {value: 'active', label: 'Active'},
                          {value: 'inactive', label: 'Inactive'},
                          {value: 'suspended', label: 'Suspended'},
                        ]}
                      />
                    </div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <button
                      type='reset'
                      className='btn btn-sm btn-white btn-active-light-primary me-2'
                      onClick={() => {
                        setPage({
                          page: 1,
                          size: 10,
                          search: '',
                        })
                        setFilter({
                          status: {value: '', label: 'Select Status'},
                        })
                      }}
                    >
                      Reset
                    </button>

                    <button
                      type='submit'
                      className='btn btn-sm btn-primary'
                      data-kt-menu-dismiss='true'
                      onClick={() => {
                        setApply(!apply)
                        setFilterOpen(false)
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='card-toolbar mt-0'>
            <button
              type='button'
              onClick={() => setOpenSupportTicketPopup(true)}
              className='btn btn-primary my-2 m-sm-0 ms-sm-3'
            >
              Create
            </button>
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>CLIENT</th>
                    <th>Email</th>
                    <th>Subject</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Luisa</td>
                    <td>
                      <a href='#' style={{color: 'inherit'}}>
                        email@myemail.com.au
                      </a>
                    </td>
                    <td>Can't send a message from the campa...</td>
                    <td>24 Jul 22</td>
                    <td>
                      <a className='badge badge-light-complete fw-bold '>Active</a>
                    </td>
                    <td>
                      <div className='row'>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 trash'>
                          <span className='svg-icon svg-icon-3'>
                            <KTSVG
                              path='/media/icons/duotune/art/trush.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Luisa</td>
                    <td>
                      <a href='#' style={{color: 'inherit'}}>
                        email@myemail.com.au
                      </a>
                    </td>
                    <td>Can't send a message from the campa...</td>
                    <td>24 Jul 22</td>
                    <td>
                      <a className='badge badge-light-danger fw-bold '>Closed</a>
                    </td>
                    <td>
                      <div className='row'>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 trash'>
                          <span className='svg-icon svg-icon-3'>
                            <KTSVG
                              path='/media/icons/duotune/art/trush.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Luisa</td>
                    <td>
                      <a href='#' style={{color: 'inherit'}}>
                        email@myemail.com.au
                      </a>
                    </td>
                    <td>Can't send a message from the campa...</td>
                    <td>24 Jul 22</td>
                    <td>
                      <a className='badge badge-light-complete fw-bold '>Active</a>
                    </td>
                    <td>
                      <div className='row'>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 trash'>
                          <span className='svg-icon svg-icon-3'>
                            <KTSVG
                              path='/media/icons/duotune/art/trush.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const SupporTicketsWrapper: FC = () => {
  return (
    <>
      <SupportTicketPage />
    </>
  )
}

export {SupporTicketsWrapper}
